<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs6  v-for="(set, i) in activeSettings" :key="set.el">
          <!-- IMAGE -->
          <picture-input 
            v-if="set.type === 'image' && !set.el.includes('.')"
            :ref="set.el"
            @change="onImageChange(activeItem[set.el], set.el)" 
            @remove="onImageRemove(activeItem[set.el])" 
            width="340" 
            height="192" 
            margin="10" 
            size="4"
            :removable="true"
            buttonClass="btn btn--flat btn--raised accent--text"
            :prefill="activeItem[set.el].url"
            :customStrings="{
              fileSize: 'The file size exceeds the limit (4MB)'
            }">
          </picture-input>
          <picture-input 
            v-if="set.type === 'image' && set.el.includes('.')"
            ref="image"
            @change="onImageChange(activeItem[set.el.split('.')[0]][set.el.split('.')[1]], 'image', i)" 
            @remove="onImageRemove(activeItem[set.el.split('.')[0]][set.el.split('.')[1]])" 
            width="340" 
            height="192" 
            margin="10" 
            size="4"
            :removable="true"
            buttonClass="btn btn--flat btn--raised accent--text"
            :prefill="activeItem[set.el.split('.')[0]][set.el.split('.')[1]].url"
            :customStrings="{
              fileSize: 'The file size exceeds the limit (4MB)'
            }">
          </picture-input>

          <!-- TOGGLE -->
          <v-switch v-if="set.type === 'toggle' && !set.el.includes('.')" :label="set.title" v-model="activeItem[set.el]"></v-switch>
          <v-switch v-if="set.type === 'toggle' && set.el.includes('.')" :label="set.title" v-model="activeItem[set.el.split('.')[0]][set.el.split('.')[1]]"></v-switch>

          <!-- INPUT -->
          <v-text-field v-if="set.type === 'input' && !set.el.includes('.')" :label="set.title" v-model="activeItem[set.el]"></v-text-field>
          <v-text-field v-if="set.type === 'input' && set.el.includes('.')" :label="set.title" v-model="activeItem[set.el.split('.')[0]][set.el.split('.')[1]]"></v-text-field>

          <!-- COLOR -->
          <color-picker v-if="set.type === 'color' && !set.el.includes('.')" :label="set.title" :color="activeItem[set.el]" v-model="activeItem[set.el]"></color-picker>
          <color-picker v-if="set.type === 'color' && set.el.includes('.')" :label="set.title" :color="activeItem[set.el.split('.')[0]][set.el.split('.')[1]]" v-model="activeItem[set.el.split('.')[0]][set.el.split('.')[1]]"></color-picker>

          <!-- SELECT -->
          <v-select 
              v-if="set.type === 'select' && !set.el.includes('.')"
              :label="set.title"
              v-model="activeItem[set.el]"
              v-bind:items="set.options"
              :item-value="set.value"
              :item-text="set.text"
            />
          <v-select 
              v-if="set.type === 'select' && set.el.includes('.')"
              :label="set.title"
              v-model="activeItem[set.el.split('.')[0]][set.el.split('.')[1]]"
              v-bind:items="set.options"
              :item-value="set.value"
              :item-text="set.text"
            />

          <!-- COLOR THEME -->
          <v-select 
              v-if="set.type === 'colorTheme' && !set.el.includes('.')"
              :label="set.title"
              v-model="activeItem[set.el]"
              v-bind:items="colorThemeOptions"
              item-value="value"
              item-text="text"
            />
          <v-select 
              v-if="set.type === 'colorTheme' && set.el.includes('.')"
              :label="set.title"
              v-model="activeItem[set.el.split('.')[0]][set.el.split('.')[1]]"
              v-bind:items="colorThemeOptions"
              item-value="value"
              item-text="text"
            />

          <!-- ICON -->
          <v-select 
              v-if="set.type === 'icon' && !set.el.includes('.')"
              :label="set.title"
              v-model="activeItem[set.el]"
              v-bind:items="iconsOptions"
              item-value="icon"
              item-text="icon"
              autocomplete
            >
            <template slot="item" slot-scope="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-avatar>
                  <i style="font-size: 24px;" class="primary--text" :class="data.item.icon"></i>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.icon"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>

          <v-select 
              v-if="set.type === 'icon' && set.el.includes('.')"
              :label="set.title"
              v-model="activeItem[set.el.split('.')[0]][set.el.split('.')[1]]"
              v-bind:items="iconsOptions"
              item-value="icon"
              item-text="icon"
              autocomplete
            >
            <template slot="item" slot-scope="data">
              <template v-if="data.item.header">
                <v-list-tile-content v-text="data.item.header"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-avatar>
                  <i style="font-size: 24px;" class="primary--text" :class="data.item.icon"></i>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.icon"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>

          <!-- SLIDER -->
          <v-slider v-if="set.type === 'slider' && !set.el.includes('.')" :label="set.title" v-model="activeItem[set.el]" thumb-label :step="set.step" :min="set.min" :max="set.max"></v-slider>
          <v-slider v-if="set.type === 'slider' && set.el.includes('.')" :label="set.title" v-model="activeItem[set.el.split('.')[0]][set.el.split('.')[1]]" thumb-label :step="set.step" :min="set.min" :max="set.max"></v-slider>

          <!-- ARRAY -->
          <div v-if="set.type === 'array' && !set.el.includes('.')" xs-12>
            <v-subheader v-text="set.title"></v-subheader>
            <v-expansion-panel>
              <v-expansion-panel-content v-for="element in activeItem[set.el]" :key="element.id">
                <div slot="header">#{{ element.id }} - {{ element.text }}</div>
                <v-card>
                  <v-card-text>
                    <block-settings-elements :activeSettings="set.children" :activeItem="element" @afterUpload="afterUpload"></block-settings-elements>
                    <a href="#" class="red--text" @click.prevent="removeElement(set, element.id)">Remove Button</a>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-btn color="green" @click.prevent="addNewElement(activeItem[set.el])">Add New</v-btn>
          </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import PictureInput from "vue-picture-input";
import BlockSettingsElements from "./_BlockSettingsElements";
import { FirebaseStorage } from "../firebase";
import AppState from "../util/AppState";
import ColorPicker from "../util/ColorPicker";
import iconsOptions from "../util/icons";

export default {
  name: "block-settings-elements",
  props: ["activeSettings", "activeItem"],
  data() {
    return {
      AppState,
      showPicker: null,
      colorThemeOptions: [
        { text: "Base", value: "g-color--base" },
        { text: "Primary", value: "g-color--primary" },
        { text: "Secondary", value: "g-color--secondary" },
        { text: "Accent", value: "g-color--accent" }
      ],
      iconsOptions
    };
  },
  components: {
    PictureInput,
    "color-picker": ColorPicker,
    BlockSettingsElements
  },
  mounted() {
    this.showPicker = null;
  },
  methods: {
    addNewElement(arr) {
      const lastObject = arr.reduce(
        (prev, current) => (prev.id > current.id ? prev : current)
      );
      const newEl = JSON.parse(JSON.stringify(lastObject));
      newEl.id += 1;
      arr.push(newEl);
    },
    removeElement(set, id) {
      this.activeItem[set.el] = this.activeItem[set.el].filter(
        e => e.id !== id
      );
    },
    onImageRemove(el) {
      const element = el;
      element.url = null;
    },
    afterUpload() {
      this.$emit("afterUpload");
    },
    onImageChange(el, ref) {
      const element = el;
      const file =
        this.$refs[ref].constructor === Array
          ? this.$refs[ref][0].file
          : this.$refs[ref].file;
      AppState.loading = true;
      // TODO: MAKE MEDIA GALLERY SO UPLOADED IMAGES ARE SHARED. ALSO LIMIT ON UPLOADS AND CHECK?
      if (file && file.name) {
        const imageRef = FirebaseStorage.images.child(
          `${Date.now()}_${file.name}`
        );
        imageRef.put(file).then(snapshot => {
          element.url = snapshot.downloadURL;
          AppState.loading = false;
          this.$emit("afterUpload");
        });
      } else {
        AppState.loading = false;
        AppState.error.text = "Your browser is not supported.";
        AppState.error.show = true;
      }
    }
  }
};
</script>
<style>
@import "../assets/themify.css";
</style>



// WEBPACK FOOTER //
// src/blocks/_BlockSettingsElements.vue